import { inject, Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, catchError, of, switchMap, filter, withLatestFrom, tap } from "rxjs";
import { DeviceActions } from "./device.actions";
import { DeviceService } from "../../services/device/device.service";
import { Store } from "@ngrx/store";
import { AppState } from "../root";
import { selectUser } from "../user/user.selectors";
import { IUser } from "../../models";
import { selectKeepers } from "./device.selectors";
import { DEVICES_KEY } from "./device.states";

const CACHE_TIME = 1000 * 60 * 10; // milliseconds * seconds * minutes = 10 minutes

@Injectable()
export class DeviceEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<AppState>);
  private deviceService = inject(DeviceService);

  loadKeepers$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceActions.loadKeepers),
    withLatestFrom(
      this.store$.select(selectUser),
      this.store$.select(selectKeepers)
    ),
    filter((user, keepers) => !!user),
    switchMap(([action, user, keepers]) => {
      if (user === null) {
        return of()
      }
      const isSnapshotFresh = action.useCache && keepers.timestamp != null && (new Date().getTime() - keepers.timestamp.getTime() < CACHE_TIME)
      if (isSnapshotFresh && keepers.timestamp != null) {
        return of(DeviceActions.loadKeepersSuccess({ devices: keepers.items, timestamp: keepers.timestamp }))
      }
      let currentUser = user as IUser
      return this.deviceService.getDevices(currentUser.organisation_id).pipe(
        map(devices => DeviceActions.loadKeepersSuccess({ devices: devices, timestamp: new Date() })),    // On success
        catchError(error => of(DeviceActions.loadKeepersFailure(error)))  // On failure
      )
    }),
  )
  );

  // region Storage
  // Logic for storing information so that it is available on reloads

  storeKeepers$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceActions.loadKeepersSuccess),
    withLatestFrom(this.store$.select(selectKeepers)),
    tap(([_, devices]) => {
      sessionStorage.setItem(DEVICES_KEY, JSON.stringify(devices.items))
    })
  ), { dispatch: false }
  );

  //endregion

}
